/* ==========================================================================
   Aquí Estamos PY — Comportamientos de interfaz
   Navegación móvil, solapas del protocolo, acordeón de FAQ y utilidades UI.
   ========================================================================== */
(function () {
  'use strict';

  var AE = window.AE || {};

  /* ------------------------------------------------ Navegación móvil */

  function initNavMovil() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-nav-toggle]');
      if (!btn) return;

      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      var abierto = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });

    // Cerrar al navegar a un ancla dentro del mismo documento
    document.addEventListener('click', function (ev) {
      var link = ev.target.closest('.mobile-nav a');
      if (!link) return;
      var panel = link.closest('.mobile-nav');
      var btn = document.querySelector('[aria-controls="' + panel.id + '"]');
      panel.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  /* ----------------------------------------------------------- Tabs */

  function initTabs(raiz) {
    (raiz || document).querySelectorAll('[data-tabs]').forEach(function (grupo) {
      if (grupo.dataset.tabsReady === '1') return;
      grupo.dataset.tabsReady = '1';

      var tabs = Array.prototype.slice.call(grupo.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function activar(tab, foco) {
        tabs.forEach(function (t) {
          var sel = t === tab;
          t.setAttribute('aria-selected', sel ? 'true' : 'false');
          t.setAttribute('tabindex', sel ? '0' : '-1');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !sel;
        });
        if (foco) tab.focus();
      }

      grupo.addEventListener('click', function (ev) {
        var tab = ev.target.closest('[role="tab"]');
        if (tab && tabs.indexOf(tab) > -1) activar(tab, false);
      });

      grupo.addEventListener('keydown', function (ev) {
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = null;
        if (ev.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (ev.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (ev.key === 'Home') next = tabs[0];
        if (ev.key === 'End') next = tabs[tabs.length - 1];
        if (next) { ev.preventDefault(); activar(next, true); }
      });

      // Estado inicial: el primero, salvo que ya haya uno marcado.
      var inicial = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      activar(inicial, false);
    });
  }

  /* --------------------------------------------------------- Acordeón */

  function initAcordeon(raiz) {
    (raiz || document).querySelectorAll('[data-faq]').forEach(function (faq) {
      if (faq.dataset.faqReady === '1') return;
      faq.dataset.faqReady = '1';

      faq.addEventListener('click', function (ev) {
        var q = ev.target.closest('.faq__q');
        if (!q) return;

        var abierto = q.getAttribute('aria-expanded') === 'true';
        var respuesta = document.getElementById(q.getAttribute('aria-controls'));

        // Un solo panel abierto por bloque
        faq.querySelectorAll('.faq__q[aria-expanded="true"]').forEach(function (otro) {
          otro.setAttribute('aria-expanded', 'false');
          var p = document.getElementById(otro.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        });

        if (!abierto) {
          q.setAttribute('aria-expanded', 'true');
          if (respuesta) respuesta.hidden = false;
        }
      });
    });
  }

  /* ------------------------------------------- Enlaces de WhatsApp */

  function initWhatsApp(raiz) {
    (raiz || document).querySelectorAll('[data-wa-link]').forEach(function (a) {
      var msg = a.getAttribute('data-wa-msg') || '';
      a.setAttribute('href', AE.waLink ? AE.waLink(msg) : '#');
    });
  }

  /* -------------------------------------- Copia al webhook externo */

  /**
   * Formularios marcados con .js-webhook-form envían una copia en JSON al
   * endpoint configurado (Zapier / Make / Sheets) y después siguen con el
   * envío nativo a Shopify. El webhook nunca bloquea el envío.
   */
  function initWebhookForms(raiz) {
    (raiz || document).querySelectorAll('form.js-webhook-form').forEach(function (form) {
      if (form.dataset.webhookReady === '1') return;
      form.dataset.webhookReady = '1';

      form.addEventListener('submit', function (ev) {
        var url = AE.config && AE.config.reserva && AE.config.reserva.webhook;
        if (!url || form.dataset.webhookEnviado === '1') return;

        if (!form.checkValidity()) return; // dejar que el navegador avise

        ev.preventDefault();
        form.dataset.webhookEnviado = '1';

        var datos = {};
        new FormData(form).forEach(function (valor, clave) {
          datos[clave.replace(/^contact\[|\]$/g, '')] = valor;
        });

        var yaEnviado = false;
        var seguir = function () {
          if (yaEnviado) return;
          yaEnviado = true;
          HTMLFormElement.prototype.submit.call(form);
        };

        AE.enviarWebhook({ tipo: 'b2b', datos: datos }).then(seguir, seguir);

        // Red de seguridad: si el endpoint cuelga, enviar igual.
        setTimeout(seguir, 4000);
      });
    });
  }

  /* ------------------------------------- Contador de metricas */

  /**
   * Anima los numeros de [data-contador-num] cuando entran en pantalla.
   * Formatea con separador de miles y coma decimal (1.500 / 4,9).
   * Si el visitante pidio menos animacion, escribe el valor final directo.
   */
  function initContadores(raiz) {
    var nodos = AE.$$('[data-contador-num]', raiz || document).filter(function (n) {
      return n.dataset.contadorListo !== '1';
    });
    if (!nodos.length) return;

    var menosMovimiento = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rellenar(txt, largo) {
      while (txt.length < largo) txt = '0' + txt;
      return txt;
    }

    function formatear(valor, decimales) {
      var signo = valor < 0 ? '-' : '';
      var abs = Math.abs(valor);
      var entero = Math.floor(abs);
      var salida = (AE.miles ? AE.miles(entero) : String(entero));
      if (decimales > 0) {
        var factor = Math.pow(10, decimales);
        var frac = Math.round((abs - entero) * factor);
        if (frac >= factor) { frac = factor - 1; }
        salida += ',' + rellenar(String(frac), decimales);
      }
      return signo + salida;
    }

    function animar(el) {
      if (el.dataset.contadorListo === '1') return;
      el.dataset.contadorListo = '1';

      var crudo = String(el.getAttribute('data-valor') || '')
        .replace(',', '.')
        .replace(/[^\d.-]/g, '');
      var decimales = (crudo.split('.')[1] || '').length;
      if (decimales > 2) decimales = 2;
      var destino = parseFloat(crudo);
      if (isNaN(destino)) { el.textContent = el.getAttribute('data-valor') || ''; return; }

      var caja = el.closest('[data-contador]');
      var duracion = parseInt(caja && caja.getAttribute('data-duracion'), 10) || 1600;

      if (menosMovimiento || !window.requestAnimationFrame) {
        el.textContent = formatear(destino, decimales);
        return;
      }

      var inicio = null;
      function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var p = Math.min(1, (ahora - inicio) / duracion);
        var suave = 1 - Math.pow(1 - p, 3);          // easeOutCubic
        el.textContent = formatear(destino * suave, decimales);
        if (p < 1) window.requestAnimationFrame(paso);
        else el.textContent = formatear(destino, decimales);
      }
      window.requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      nodos.forEach(animar);
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); observador.unobserve(e.target); }
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });

    nodos.forEach(function (n) { observador.observe(n); });
  }

  /* --------------------------------------- Marquesina de logos */

  /**
   * La marquesina recicla dos grupos idénticos desplazando la pista -50%.
   * Para que no se vea un hueco, cada grupo tiene que ser al menos tan ancho
   * como la pantalla. Liquid no puede medir, así que acá se clonan los logos
   * hasta cubrirla. Los clones van aria-hidden para no repetirlos en lectores.
   */
  function initMarquesinas(raiz) {
    (raiz || document).querySelectorAll('.marquesina').forEach(function (mq) {
      var pista = mq.querySelector('.marquesina__pista');
      if (!pista) return;

      // La guarda va antes de clonar: si initMarquesinas corre dos veces
      // (por ejemplo al recargar una seccion en el editor de temas) los
      // logos se duplicarian otra vez sobre los ya clonados.
      if (mq.dataset.marquesinaLista === '1') return;
      mq.dataset.marquesinaLista = '1';

      var grupos = pista.querySelectorAll('.marquesina__grupo');
      if (grupos.length < 2) return;

      var g1 = grupos[0];
      var g2 = grupos[1];
      var base = Array.prototype.slice.call(g1.children);
      if (!base.length) return;

      function completar() {
        var objetivo = mq.getBoundingClientRect().width * 1.25;
        var vueltas = 0;
        while (g1.scrollWidth < objetivo && vueltas < 25) {
          base.forEach(function (nodo) {
            var a = nodo.cloneNode(true);
            var b = nodo.cloneNode(true);
            a.setAttribute('aria-hidden', 'true');
            b.setAttribute('aria-hidden', 'true');
            // Los dos grupos deben crecer igual o el bucle se desalinea
            g1.appendChild(a);
            g2.appendChild(b);
          });
          vueltas++;
        }
      }

      // Medir recién cuando las imágenes tienen tamaño: si se mide antes,
      // los anchos dan casi cero y se clonan muchos más logos de los necesarios.
      if (document.readyState === 'complete') completar();
      else window.addEventListener('load', completar, { once: true });

      var temporizador;
      window.addEventListener('resize', function () {
        clearTimeout(temporizador);
        temporizador = setTimeout(completar, 250);
      });
    });
  }

  /* ------------------------------------------------- Marcar página */

  function marcarPaginaActual() {
    // Quitar la barra final deja la home como cadena vacia, que es falsy:
    // sin este normalizado el enlace «Inicio» nunca se marcaba como actual.
    function normalizar(ruta) {
      var limpia = (ruta || '').split('#')[0].split('?')[0].replace(/\/+$/, '');
      return limpia === '' ? '/' : limpia;
    }

    var actual = normalizar(window.location.pathname);
    document.querySelectorAll('.header__nav a, .mobile-nav a').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href === null || href.charAt(0) !== '/') return;
      if (normalizar(href) === actual) a.setAttribute('aria-current', 'page');
    });
  }

  /* ------------------------------------------- Aparición al hacer scroll */

  /* El contenido nace visible en el CSS: la clase js-revelar sólo se agrega
     cuando este script corre y hay soporte de IntersectionObserver, así que
     un fallo del JavaScript nunca deja una sección invisible.
     Se excluyen los encabezados de página: animar lo que está sobre la línea
     de flotación retrasa el LCP y suma desplazamiento visible. */
  function initRevelar(raiz) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var selector = [
      '.section__head',
      '.valor',
      '.ruta__paso',
      '.extra',
      '.plan',
      '.testi',
      '.persona',
      '.proposito',
      '.historia__lista > li',
      '.historia__marco',
      '.cobertura__media',
      '.cobertura__texto .cobertura__banda',
      '.garantia__caja',
      '.cta-band'
    ].join(',');

    var nodos = AE.$$(selector, raiz || document).filter(function (n) {
      if (n.hasAttribute('data-revelar')) return false;
      // Nada dentro de un hero ni de un panel de solapas: el hero es lo
      // primero que se ve y las solapas ya traen su propia transición.
      return !n.closest('.hero, .page-hero, .b2b-hero, [role="tabpanel"]');
    });
    if (!nodos.length) return;

    document.documentElement.classList.add('js-revelar');

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('esta-visible');
        observador.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });

    nodos.forEach(function (nodo) {
      nodo.setAttribute('data-revelar', '');

      // Escalonado corto entre hermanos del mismo grupo, tope de 4 pasos
      // para que el último elemento de una fila no se haga esperar.
      var hermanos = nodo.parentNode ? nodo.parentNode.children : [];
      var i = Array.prototype.indexOf.call(hermanos, nodo);
      if (i > 3) i = 3;
      if (i > 0) nodo.style.setProperty('--revelar-i', i);

      observador.observe(nodo);
    });
  }

  /* ------------------------------------- Formulario B2B en dos pasos */

  function initB2BPasos(raiz) {
    (raiz || document).querySelectorAll('[data-b2b-pasos]').forEach(function (caja) {
      if (caja.dataset.b2bListo === '1') return;

      var paneles = AE.$$('[data-b2b-panel]', caja);
      if (paneles.length < 2) return;

      caja.dataset.b2bListo = '1';
      // Recién ahora se muestran la barra de progreso y el botón «Continuar»:
      // si el script no llegara a correr, el formulario queda como una sola
      // pantalla con su botón de envío, que es como funcionaba antes.
      caja.classList.add('is-activo');

      var tabs = AE.$$('[data-b2b-tab]', caja);

      function mostrar(n, mover) {
        paneles.forEach(function (p) {
          p.hidden = p.getAttribute('data-b2b-panel') !== String(n);
        });
        tabs.forEach(function (t) {
          var i = parseInt(t.getAttribute('data-b2b-tab'), 10);
          t.classList.toggle('is-actual', i === n);
          t.classList.toggle('is-hecho', i < n);
        });
        // Sólo al cambiar de paso, nunca al cargar la página.
        if (!mover) return;
        var y = caja.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
      }

      function valido(panel) {
        var campos = AE.$$('input, select, textarea', panel);
        for (var i = 0; i < campos.length; i++) {
          if (campos[i].checkValidity && !campos[i].checkValidity()) {
            if (campos[i].reportValidity) campos[i].reportValidity();
            return false;
          }
        }
        return true;
      }

      caja.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-b2b-next]')) {
          ev.preventDefault();
          if (valido(paneles[0])) mostrar(2, true);
        }
        if (ev.target.closest('[data-b2b-prev]')) {
          ev.preventDefault();
          mostrar(1, true);
        }
      });

      mostrar(1, false);
    });
  }

  /* ------------------------------------------------------ Arranque */

  function init(raiz) {
    initTabs(raiz);
    initAcordeon(raiz);
    initWhatsApp(raiz);
    initWebhookForms(raiz);
    initContadores(raiz);
    initMarquesinas(raiz);
    initB2BPasos(raiz);
    initRevelar(raiz);
  }

  function arrancar() {
    initNavMovil();
    marcarPaginaActual();
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // Re-inicializar cuando el editor de temas de Shopify recarga una sección.
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });

  window.AE = window.AE || {};
  window.AE.initUI = init;
})();
